import { gql } from '@apollo/client'
import { ProjectItemFragments } from '../fragments/projectItem.fragments'

export const GetProjectsQuery = gql`
    query getProjectsQuery($input: GetResultsInput!) {
        getProjects(input: $input) {
            count
            projects {
                ...recentlyViewedAndAllProjects
            }
            facets {
                name
                values
            }
            projectGroupCounts {
                groupId
                totalCount
            }
        }
    }
    ${ProjectItemFragments.RecentlyViewedAndAllProjects}
`

export const RecentlyViewedProjectsQuery = gql`
    query getRecentlyViewedProjectsQuery {
        getRecentlyViewedProjects {
            ...recentlyViewedAndAllProjects
        }
    }
    ${ProjectItemFragments.RecentlyViewedAndAllProjects}
`

export const GetProjectQuery = gql`
    query getProjectQuery($projectId: String!) {
        getProject(projectId: $projectId) {
            ...projectDetails
            id
            projectSettings {
                collectData
                familyNumberFormat
                unitOfMeasure
                elementTreeView
            }
            publishSettings {
                notesToSpecifier
                bookmarks
                cover
                excludeSectionTitle
                excludeTermSection
                exportAsDocx
                exportAsFullManual
                exportAsIndividualFiles
                exportAsPDF
                fontColorsOn
                hyperlinksActive
                includeFolderForDivision
                notesToSpecifier
                prefixWithSectionFileNamesWithSection
                revisionHistory
                widowOrphanControl
                includeTrackChanges
            }
            projectStyles {
                ...projectStyles
            }
            projectHeaderAndFooters {
                ...projectHeaderAndFooters
            }
        }
    }

    ${ProjectItemFragments.ProjectStyles}
    ${ProjectItemFragments.ProjectDetails}
    ${ProjectItemFragments.ProjectHeaderAndFooters}
`
export const GetProjectNotesQuery = gql`
    query getProjectNotesQuery(
        $projectId: String!
        $projectNoteSearchInput: ProjectNoteSearchInput!
    ) {
        getProject(projectId: $projectId) {
            ...projectDetails
            projectNotes(input: $projectNoteSearchInput) {
                id
                name
                description
                projectElementDescription
                noteType
                projectElementId
                noteBreadCrumbs
                contentItemId
                metadata {
                    created
                    creatorId
                    updated
                }
                dueDate
                state
                comments {
                    id
                    text
                    metadata {
                        created
                        creatorId
                        updated
                    }
                }
            }
            projectSettings {
                collectData
                familyNumberFormat
                unitOfMeasure
            }
        }
    }
    ${ProjectItemFragments.ProjectDetails}
`
/** Lightweight query — only fetches what's needed to populate the task indicator set. */
export const GetProjectNoteContentItemIdsQuery = gql`
    query getProjectNoteContentItemIdsQuery(
        $projectId: String!
        $projectNoteSearchInput: ProjectNoteSearchInput!
    ) {
        getProject(projectId: $projectId) {
            projectNotes(input: $projectNoteSearchInput) {
                id
                contentItemId
            }
        }
    }
`

export const GetProjectElementsQuery = gql`
    query getProjectElementsQuery($input: GetProjectElementsResultsInput!) {
        getProjectElements(input: $input) {
            count
            projectElements {
                id
                dataType
                metadata {
                    updated
                }
                name
                projectElementMetadata {
                    assignedUser
                    targetLOD
                    currentLOD
                    state
                }
            }
        }
    }
`

export const GetProjectTeamQuery = gql`
    query getProjectTeamQuery($projectId: String!) {
        getProject(projectId: $projectId) {
            id
            projectTeam {
                ...projectTeam
            }
        }
    }
    ${ProjectItemFragments.ProjectTeam}
`

export const GetOwnerDeletionImpactDataQuery = gql`
    query getOwnerDeletionImpactData($ownerId: String!) {
        getOwnerDeletionImpactData(ownerId: $ownerId) {
            status
            message
            affectedProjectsCount
            affectedBestPracticesCount
        }
    }
`

export const GetExportStatusQuery = gql`
    query getExportStatus($input: GetBackendProcessStatusInput!) {
        getExportStatus(input: $input) {
            errorMessage
            progressPercentage
            state
            output {
                downloadURL
                firmId
                projectId
                status
                faultyFamilies
                errorMessage
                instanceId
            }
        }
    }
`

export const GetImportProjectProductFamilyStatusQuery = gql`
    query getImportProjectProductFamilyStatus($input: GetBackendProcessStatusInput!) {
        getImportProjectProductFamilyStatus(input: $input) {
            errorMessage
            errorPercentage
            progressPercentage
            state
            output {
                firmId
                projectId
                status
                importResult {
                    fileName
                    productFamilyId
                    productFamilyIdGuid
                    status
                }
                errorMessage
                importInstanceId
            }
        }
    }
`

export const GetOfficeMasterPublishProductFamilyStatusQuery = gql`
    query getOfficeMasterPublishProductFamilyStatus($input: GetBackendProcessStatusInput!) {
        getOfficeMasterPublishProductFamilyStatus(input: $input) {
            errorMessage
            progressPercentage
            state
            output {
                firmId
                projectId
                status
                errorMessage
                instanceId
                productFamilyPublishResults {
                    productFamilyId
                    status
                    errorMessage
                }
            }
        }
    }
`